import React from 'react';
import Layout from '../../reusables/layout/layout';
import Login from '../../Component/loginform/login';


const PaymentLoginTradeTest = () => {


  return (
    <div >
      <Layout>
        <Login examType={"TRADE TEST"} url={'/individual/login/05'} navigateTo={'/requisition/tradetest'}
        homeLink={"https://tradetest.examsboard.lagosstate.gov.ng/"} />
      </Layout>
    </div>
  );
};

export default PaymentLoginTradeTest;